import IconDisc from "@web-ui/components/IconDisc";

/*
 * Empty: what a list or a card says when it has nothing to show (owner 2026-10-13; the apps had eight
 * copies). A quiet centred block: an optional icon disc, the title, a line, an action. It reveals on
 * mount. It is static content, not a live region: a table that re-renders must not re-announce it.
 * Fits DataTable's `empty` slot (the frame's own padding is kept, the block's dropped).
 */
type EmptyProps = {
    className?: string;
    icon?: string;
    title: React.ReactNode;
    description?: React.ReactNode;
    action?: React.ReactNode;
};

const Empty = ({ className, icon, title, description, action }: EmptyProps) => (
    <div className={`empty motion-reveal ${className || ""}`}>
        {icon ? <IconDisc className="empty__icon" tone="neutral" icon={icon} size="lg" /> : null}
        <div className="empty__title">{title}</div>
        {description ? <div className="empty__description">{description}</div> : null}
        {action ? <div className="empty__action">{action}</div> : null}
    </div>
);

export default Empty;
